import http from "../http-common";
/* eslint-disable */
class PsikologisOpsiJawabanService {
  getList(page, itemPerPage, keyword, id) {
    return http.get(
      "/psikologis-opsi-jawaban/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&id=" +
        id,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("opsi", data.opsi);
    bodyFormData.append("psikologis_pertanyaan_id", id);
    bodyFormData.append("nilai", data.nilai);
    bodyFormData.append("urutan", data.urutan);

    return http.post("/psikologis-opsi-jawaban", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("opsi", data.opsi);
    bodyFormData.append("psikologis_pertanyaan_id", id);
    bodyFormData.append("nilai", data.nilai);
    bodyFormData.append("urutan", data.urutan);

    return http.put(`/psikologis-opsi-jawaban/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/psikologis-opsi-jawaban/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new PsikologisOpsiJawabanService();
